import { createSlice } from '@reduxjs/toolkit';
import {LABELGENAPI } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const addresssenderslice = createSlice({
    name: 'addresssender',
    initialState: {
        data: [],
        meta: [],
        loading: false,
        hasErrors: false,
        message: "",
        messageType:""
    },
    reducers: {
        getSenderAddress: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getSenderAddressSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                hasErrors: false,
                loading: false
            }
        },
        getSenderAddressFailure: (state, action) => {
            return {
                ...state,              
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        putSenderAddress: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false,
                message: ""
            }
        },
        putSenderAddressSuccess: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: false,
                messageType:"success",
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },
        putSenderAddressFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },
        deleteSenderAddress: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false,
                message: ""
            }
        },
        deleteSenderAddressSuccess: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: false,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        deleteSenderAddressFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        postSenderAddress: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false,
                message: ""
            }
        },
        postSenderAddressSuccess: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: false,
                messageType:"success",
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }                
            
        },
        postSenderAddressFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                messageType:"failure",
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
            
        },
        resetSenderAddress: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                message: "",
            }
        },

        


    }
})
export const { getSenderAddress, getSenderAddressSuccess, getSenderAddressFailure, 
    putSenderAddress, putSenderAddressSuccess, putSenderAddressFailure, deleteSenderAddress, deleteSenderAddressSuccess, deleteSenderAddressFailure,
    postSenderAddress, postSenderAddressSuccess, postSenderAddressFailure, resetSenderAddress } = addresssenderslice.actions;


export const fetchSenderAddress = data =>dispatch => {    
    dispatch(getSenderAddress());
    try {
        LABELGENAPI
            .get('/settings/address-sender')
            .then(function (response) {
                dispatch(getSenderAddressSuccess(response));
            })
            .catch(function (error) {
                dispatch(getSenderAddressFailure(error.response));
            });
    } catch (error) {
        dispatch(getSenderAddressFailure());
    }
};

export const storeSenderAddress = (userid,data) => dispatch => {
    dispatch(postSenderAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/address-sender', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postSenderAddressSuccess(response));
                dispatch(fetchSenderAddress());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_CREATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });   
            }).catch(function (error) {
                dispatch(postSenderAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_CREATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postSenderAddressFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SENDER_ADDRESS_CREATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}



export const updateSenderAddress = (userid, id, data) => dispatch => {   
    dispatch(putSenderAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.patch('/settings/address-sender/' + id, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putSenderAddressSuccess(response));
                dispatch(fetchSenderAddress());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                }); 
            }).catch(function (error) {
                dispatch(putSenderAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putSenderAddressFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SENDER_ADDRESS_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }

}

export const destorySenderAddress = (userid,id) => dispatch => {
    dispatch(deleteSenderAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI
            .delete("/settings/address-sender/" + id, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(deleteSenderAddressSuccess(response));
                dispatch(fetchSenderAddress());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_DELETE',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                }); 
            })
            .catch(function (error) {
                dispatch(deleteSenderAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'SENDER_ADDRESS_DELETE',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            });
    } catch (error) {
        dispatch(deleteSenderAddressFailure(error));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'SENDER_ADDRESS_DELETE',
            action: 'FAILURE',
            request_data: JSON.stringify(id),
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
};
export const resetSenderAddressState = data => dispatch => {    
    dispatch(resetSenderAddress());
}


export default addresssenderslice.reducer;
